import { Controller } from 'stimulus';

class FormSaveAndBackController extends Controller {
  onBackClick(e) {
    const formData = new FormData(this.element);
    const backUrl = e.target.getAttribute('data-back-url');

    formData.set('save_and_back', 1);

    window.axios
      .post(this.element.action, formData)
      .then(() => {
        window.location.href = backUrl;
      })
      .catch(() => {
        window.location.href = backUrl;
      });

    return false;
  }
}

FormSaveAndBackController.targets = [];

export default FormSaveAndBackController;
